import { render, staticRenderFns } from "./AddPolicyLocationModal.vue?vue&type=template&id=8763b862&scoped=true&"
import script from "./AddPolicyLocationModal.vue?vue&type=script&lang=ts&"
export * from "./AddPolicyLocationModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddPolicyLocationModal.vue?vue&type=style&index=0&id=8763b862&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8763b862",
  null
  
)

export default component.exports